import { useSyncExternalStore } from 'react';
import {
  getVisibilityState,
  subscribeVisibility,
  isStoreVisible,
  setShowAll,
  toggleStoreVisibility,
  setVisibleInactiveIds,
} from '../stores/adminStoreVisibilityStore';

export function useStoreVisibility() {
  const state = useSyncExternalStore(subscribeVisibility, getVisibilityState);

  return {
    showAll: state.showAll,
    visibleInactiveIds: state.visibleInactiveIds,
    isStoreVisible,
    setShowAll,
    toggleStoreVisibility,
    setVisibleInactiveIds,
  };
}
